import { Box, ButtonBase, Typography, IconButton } from "@mui/material";
import { useEffect, useState, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";
import Footer from "../home/Footer";
import logo from "../../assets/icons/logo-blog.png";
import { useSearchParams } from "react-router-dom";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const About = () => {
  const [modules, setModules] = useState([]);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getData } = useAuth();
  const [searchParams] = useSearchParams();
  const scrollContainerRef = useRef(null);

  const code = useMemo(() => searchParams.get("code"), [searchParams]);

  const selectedModule = useMemo(
    () => modules.find((m) => String(m.id) === code),
    [modules, code]
  );

  const selectedClient = useMemo(
    () => category.find((c) => c.categories === selectedModule?.categories),
    [category, selectedModule]
  );

  const filteredModules = useMemo(() => [selectedModule], [selectedModule]);

  const otherModules = useMemo(
    () => modules.filter((module) => String(module.id) !== code),
    [modules, code]
  );

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getData("proccess.php", "modules_V2");
        if (response.success) {
          setModules(response.data);
        } else {
          throw new Error(response.message || "Failed to load Modules");
        }

        const cate = await getData("proccess.php", "our_clients_V2");
        if (cate.success) {
          setCategory(cate.data);
        } else {
          throw new Error(cate.message || "Failed to load categories");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message || "Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error || !code || !selectedModule) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography color="error">{error || "Module not found"}</Typography>
      </Box>
    );
  }

  const bgUrl = selectedClient?.image
    ? `https://mindsinaction.com.na/assets/media/pictures/${selectedClient.image}`
    : null;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="parentContainer">

      <Box
        width={"100%"}
        height={"auto"}
        paddingTop={'10vh'}
        sx={{
          backgroundColor: "#e7f1f5",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          width={"100%"}
          maxWidth={"1200px"}
          height={"auto"}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
          }}
        >
          <Box
            width={"100%"}
            display={"flex"}
            flexWrap={"wrap-reverse"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={"1rem"}
            margin={"1rem 0"}
          >
            <Box
              sx={{
                flex: 1,
                minWidth: { xs: "200px", sm: "200px", md: "250px" },
                maxWidth: { xs: "350px", sm: "400px", md: "600px" },
                height: { xs: "auto", sm: "370px" },
                overflow: "hidden",
                borderBottomRightRadius: "10%",
                borderTopLeftRadius: "10%",
              }}
            >
              <img
                src={
                  selectedModule.image
                    ? `https://mindsinaction.com.na/assets/media/pictures/${selectedModule.image}`
                    : `${logo}`
                }
                style={{
                  width: "100%",
                }}
                alt={selectedModule.module_name}
              />
            </Box>
            {filteredModules.map((module) => (
              <Box
                key={module.id}
                sx={{
                  flex: 1,
                  minWidth: { xs: "200px", sm: "200px", md: "250px" },
                  maxWidth: { xs: "350px", sm: "400px", md: "600px" },
                  height: { xs: "auto", sm: "370px" },
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    minHeight: "370px",
                    background: "linear-gradient(to right, #3b76b2 ,#32a059)",
                    borderRadius: "1rem",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      padding: "1rem",
                      textAlign: "start",
                    }}
                  >
                    <Typography
                      variant="h4"
                      fontWeight={700}
                      fontSize={"1.5rem"}
                      margin={"1rem 0"}
                      color="#ffffffff"
                    >
                      {module.module_name}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "space-around",
                        padding: ".2rem 1rem",
                        backgroundColor: "#ffffffff",
                        borderRadius: "1rem",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" color="#000000ff">
                          Target Age Groups
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight={700}
                          color="#000000ff"
                        >
                          {module.age_target_group} +
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="body2" color="#000000ff">
                          Period Trimester
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight={700}
                          color="#000000ff"
                        >
                          {module.duration}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="body2" color="#000000ff">
                          Total Hours
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight={700}
                          color="#000000ff"
                        >
                          {module.total_hours}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="h5"
                        fontWeight={700}
                        color="#ffffffff"
                        padding={"1rem 0"}
                      >
                        Description
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        height: { xs: "auto", sm: "100px" },
                        overflow: "auto",
                        marginBottom: "1rem",
                      }}
                    >
                      <Typography
                        dangerouslySetInnerHTML={{ 
                          __html: module.description 
                        }}
                        variant="body1"
                        sx={{
                          fontSize: "1rem",
                          color: "#ffffffff",
                          textAlign: "start",
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "space-around",
                        margin: "1rem 0",
                        backgroundColor: "#fff",
                        padding: "0 1rem",
                      }}
                    >
                      <Box
                        flex={1}
                        minWidth={"100px"}
                        borderRight={".1rem solid #3b76b2"}
                      >
                        <Typography fontWeight={700} color="#3b76b2">
                          TIME
                        </Typography>
                        <Typography variant="body" color="#000000ff">
                          {module.delivery_time}
                        </Typography>
                      </Box>
                      <Box
                        flex={1}
                        minWidth={"100px"}
                        borderRight={".1rem solid #3b76b2"}
                      >
                        <Typography fontWeight={700} color="#3b76b2">
                          EQUIPMENT
                        </Typography>
                        <Typography variant="body" color="#000000ff">
                          LAPTOP
                        </Typography>
                      </Box>
                      <Box flex={1} minWidth={"100px"}>
                        <Typography fontWeight={700} color="#3b76b2">
                          FEE
                        </Typography>
                        <Typography
                          variant="h5"
                          color="#ad9534ff"
                          fontWeight={700}
                          fontSize={{xs: '1rem', md: '1.8rem'}}
                        >
                          N$ {module.price}.00
                        </Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                        marginTop: "15px",
                      }}
                    >
                      <Link to={`/get-started`}>
                        <ButtonBase
                          sx={{
                            backgroundColor: "#ffffffff",
                            color: "#000000ff",
                            padding: ".5rem 1rem",
                            border: "none",
                            borderRadius: "1rem",
                          }}
                        >
                          Register
                        </ButtonBase>
                      </Link>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Other Modules with Horizontal Scroll */}
          <Box width={"100%"} sx={{ marginTop: "2rem" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                borderTop: ".1rem solid #000000ff",
                marginBottom: "1rem",
              }}
            >
              <Typography
                sx={{
                  backgroundColor: "#000000ff",
                  padding: ".3rem 1rem",
                  color: "#fff",
                }}
              >
                Other Modules
              </Typography>
            </Box>

            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              {/* Left Scroll Button */}
              <IconButton
                onClick={scrollLeft}
                sx={{
                  position: "absolute",
                  left: -20,
                  zIndex: 10,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  color: "black",
                  "&:hover": {
                    backgroundColor: "rgba(226, 226, 226, 1)",
                  },
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <ChevronLeftIcon />
              </IconButton>

              {/* Other Modules Container */}
              <Box
                ref={scrollContainerRef}
                sx={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "2rem",
                  padding: "1rem 0.5rem",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  width: "100%",
                }}
              >
                {otherModules.map(
                  (module, index) =>
                    module.categories === selectedModule.categories && (
                      <Box
                        key={module.id}
                        sx={{
                          flex: "0 0 auto",
                          width: '200px',
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        data-aos="zoom-in"
                        data-aos-delay={`${200 + index * 100}`}
                      >
                        <Box
                          className="box-hover"
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: '50px',
                            borderRadius: "40px",
                            overflow: "hidden",
                          }}
                        >
                          <ButtonBase
                            component={Link}
                            to={`?code=${module.id}`}
                            sx={{ width: "100%", height: "100%", 
                              background: '#3b76b2',
                              padding: '.5rem 1rem'
                            }}
                            onClick={scrollToTop()}
                          >
                            <Typography
                              variant="h6"
                              textAlign="center"
                              color="rgb(255, 255, 255)"
                              fontWeight={700}
                              fontSize={"1rem"}
                              sx={{
                                minHeight: "60px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {module.module_name}
                            </Typography>
                          </ButtonBase>
                        </Box>
                        
                      </Box>
                    )
                )}
              </Box>

              {/* Right Scroll Button */}
              <IconButton
                onClick={scrollRight}
                sx={{
                  position: "absolute",
                  right: -20,
                  zIndex: 10,
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  color: "black",
                  "&:hover": {
                    backgroundColor: "rgba(226, 224, 224, 1)",
                  },
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <ChevronRightIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;
